import { Helmet } from "react-helmet";
import wrapperHOC from "@Utils/wrapperHOC";
import V2Footer from "@Components/V2Footer/V2Footer";
// Navbar and Reveal are shared components rather than per-page copies, so the
// v2 pages keep one source of truth for the scroll/hover interactions.
import Navbar from "@Components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Steps from "./components/Steps/Steps";
import WhyBook from "./components/WhyBook/WhyBook";
import styles from "./HowItWorksV2.module.scss";
import { ABOUT_URL, BLOG_URL } from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";

const HowItWorksV2 = () => {
  const { t } = useTranslationHook();

  return (
    <div className={styles.page}>
      <Helmet title={t("howitworks.v2.meta.title")}>
        <meta name="description" content={t("howitworks.v2.meta.description")} />
        {/* Instrument Sans — the design font, loaded only on this page */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&display=swap"
        />
      </Helmet>

      <Navbar
        links={[
          { label: "navbar.v2.blogs", href: BLOG_URL },
          { label: "navbar.v2.aboutus", href: ABOUT_URL },
        ]}
      />
      <Hero />
      <Steps />
      <WhyBook />
      <V2Footer />
    </div>
  );
};

export default wrapperHOC(HowItWorksV2, {
  componentName: "HowItWorksV2-Page",
  showForChina: true,
});
